import { exciseWarehouseRepo } from "./exciseWarehouse.repo";
import {
  IGenerisanjeDozvolaDokumentaPayload,
  ISkladisteChangePayload,
  ISkladisteIdPayload,
} from "./exciseWarehouse.types";

class ExciseWarehouseService {
  getSvaAkciznaSkladistaZaDrustvo = () => {
    return exciseWarehouseRepo.getSvaAkciznaSkladistaZaDrustvo();
  };

  createGenerisanjeDozvolaDokumenta = (
    payload: IGenerisanjeDozvolaDokumentaPayload
  ) => {
    return exciseWarehouseRepo.createGenerisanjeDozvolaDokumenta(payload);
  };

  createIstorijaZahtevaZaSkladiste = (payload: ISkladisteIdPayload) => {
    return exciseWarehouseRepo.createIstorijaZahtevaZaSkladiste(payload);
  };

  createIstorijaResenjaZaSkladiste = (payload: ISkladisteIdPayload) => {
    return exciseWarehouseRepo.createIstorijaResenjaZaSkladiste(payload);
  };

  postKreiranjeZahtevaZaIzmenuObnovuIliPrekidVazenjaDozvole = (
    payload: ISkladisteChangePayload
  ) => {
    return exciseWarehouseRepo.postKreiranjeZahtevaZaIzmenuObnovuIliPrekidVazenjaDozvole(
      payload
    );
  };
}

export const exciseWarehouseService = new ExciseWarehouseService();
